import React from "react";
import styles from "./monster-detail.module.css";
import { LOCALES, NORMAL_STATUS_TYPE, SAVIOR_ATTRIBUTE, SAVIOR_CLASS, SKILL_TYPE } from "../../constants";
import { getSkillDescWithFlavorTexts } from "../../functions/stringFunctions";
import getImageFileName from "../../functions/getImageFileName";
import { getUIText } from "../../translation";
import { v4 } from "uuid";

const PERCENT_STAT_LIST = ["crit_rate", "crit_dmg", "eff_rate", "eff_resist", "def_eff_rate", "def_eff_resist"];
const STAT_ORDER = [
    "atk",
    "hp",
    "def",
    "spd",
    "crit_rate",
    "crit_dmg",
    "eff_rate",
    "eff_resist",
    "def_eff_rate",
    "def_eff_resist",
    "super_armor",
];

const getStatValueText = (key, value) => {
    if (PERCENT_STAT_LIST.includes(key)) return `${value / 100}%`;
    if (key === "super_armor") return `${value}`;
    return value.toLocaleString("ko-KR");
};

export default function MonsterDetail({ lang, monster }) {
    const eng = monster.attr.replace("NUAT_", "").toLowerCase();

    return (
        <div className={`${styles["detail"]} ${monster.isBoss ? styles["boss"] : ""}`}>
            <div className={styles["header"]}>
                <div className={`${styles["portrait"]} ${styles[eng]}`}>
                    <img src={`${process.env.PUBLIC_URL}/images/icon/portrait/monster/${monster.img}`} alt={monster.name} />
                </div>
                <div className={styles["header-info"]}>
                    <h3>{monster.name}</h3>
                    <div className={styles["badges"]}>
                        <span className={`${styles["badge"]} ${styles[eng]}`}>{SAVIOR_ATTRIBUTE[monster.attr][lang]}</span>
                        <span className={styles["badge"]}>{SAVIOR_CLASS[monster.class][lang]}</span>
                        <span className={styles["badge"]}>
                            {getUIText(lang, "monster.detail.level")} {monster.level}
                        </span>
                        {monster.isBoss && (
                            <span className={`${styles["badge"]} ${styles["boss-badge"]}`}>{getUIText(lang, "monster.card.boss")}</span>
                        )}
                    </div>
                </div>
            </div>

            <div className={styles["stat-grids"]}>
                {STAT_ORDER.map((key) => (
                    <div className={styles["stat-item"]} key={key}>
                        <span className={styles["stat-label"]}>{NORMAL_STATUS_TYPE[key][lang]}</span>
                        <span className={styles["stat-value"]}>{getStatValueText(key, monster.stats[key])}</span>
                    </div>
                ))}
            </div>

            {monster.immuneList && monster.immuneList.length > 0 && (
                <div className={styles["immune-section"]}>
                    <h4>{getUIText(lang, "monster.detail.immune")}</h4>
                    <div className={styles["immune-list"]}>
                        {monster.immuneList.map((immune) => (
                            <span className={styles["immune-chip"]} key={v4()}>
                                {immune[lang]}
                            </span>
                        ))}
                    </div>
                </div>
            )}

            <div className={styles["skills-section"]}>
                <h4>{getUIText(lang, "monster.detail.skills")}</h4>
                <div className={styles["skills"]}>
                    {monster.skills.map((skill) => {
                        const descObj = getSkillDescWithFlavorTexts(lang, skill.desc);

                        return (
                            <div className={styles["skill"]} key={skill.id}>
                                <img
                                    className={styles["skill-icon"]}
                                    src={`${process.env.PUBLIC_URL}/images/icon/skills/monster/${skill.img}`}
                                />
                                <div className={styles["skill-body"]}>
                                    <div className={styles["skill-header"]}>
                                        <span className={styles["skill-name"]}>{skill.name[lang]}</span>
                                        <span className={styles["skill-type"]}>{SKILL_TYPE[skill.type][lang]}</span>
                                        {skill.cooltime > 0 && (
                                            <span className={styles["skill-cooltime"]}>
                                                {skill.cooltime} {getUIText(lang, "savior.modal.skills.badge.turn")}
                                            </span>
                                        )}
                                    </div>
                                    <div className={styles["skill-desc"]} dangerouslySetInnerHTML={{ __html: descObj.desc }}></div>
                                    {descObj.buffList.length > 0 && (
                                        <div className={styles["flavor-texts"]}>
                                            {descObj.buffList.map((buff) => (
                                                <div key={buff.id}>
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/images/icon/buff/${getImageFileName(buff.name[LOCALES.KO])}.webp`}
                                                    />
                                                    &nbsp;
                                                    <span className={styles["buff-name"]}>{buff.name[lang]}</span>&nbsp;:&nbsp;
                                                    <span>{buff.desc[lang]}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
